import { App } from 'vue';
import PrimeVue, { PrimeVueConfiguration } from 'primevue/config';
import Lara from '@primevue/themes/lara';
import { definePreset } from '@primevue/themes';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import Ripple from 'primevue/ripple';
import Select from 'primevue/select';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Drawer from 'primevue/drawer';
import ToggleSwitch from 'primevue/toggleswitch';
import DatePicker from 'primevue/datepicker';

const MyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#f5f4fe',
      100: '#edeafd',
      200: '#ddd8fc',
      300: '#c3b9f9',
      400: '#a691f4',
      500: '#8864ee',
      600: '#723be3',
      700: '#6831d0',
      800: '#5728af',
      900: '#49238f',
      950: '#2c1461',
    },
  },
});

export const applyPrimeVue = (app: App) => {
  app.use(PrimeVue, {
    theme: {
      preset: MyPreset,
      options: {
        darkModeSelector: 'class',
      },
    },
    locale: {
      dayNames: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
      dayNamesShort: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
      dayNamesMin: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'],
      monthNames: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
      monthNamesShort: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
      today: 'היום',
      firstDayOfWeek: 0,
      dateFormat: 'dd.mm.yy',
      fileSizeTypes: [],
    },
    pt: {
      button: {
        root: { class: '!rounded-md border' },
        label: { class: '!font-medium' },
      },
    },
  } satisfies PrimeVueConfiguration);
  app.directive('ripple', Ripple);
  app.use(ConfirmationService);
  app.use(DialogService);
  app.use(ToastService);
  // unplugin-vue-components' PrimeVueResolver still ships the PrimeVue 3 name list
  // (InputSwitch, Calendar, Dropdown, Sidebar...), so every component renamed in
  // PrimeVue 4 fails to auto-resolve and silently renders nothing. Register those here.
  app.component('Toast', Toast);
  app.component('Select', Select);
  app.component('IconField', IconField);
  app.component('InputIcon', InputIcon);
  app.component('Drawer', Drawer);
  app.component('ToggleSwitch', ToggleSwitch);
  app.component('DatePicker', DatePicker);
};
